import { detect } from 'detect-browser';

const browser = detect();

export const isSafari = () => (browser?.name ? ['safari', 'ios'].includes(browser.name) : null);

const isFirefox = () => (browser?.name ? ['firefox', 'fxios'].includes(browser.name) : null);

const isChromium = () => (browser?.name ? ['chrome', 'edge-chromium', 'chromium-webview', 'crios'].includes(browser.name) : null);

const isFeatureAllowed = (feature: string) => (document as any).featurePolicy?.allowsFeature(feature);

export const isTeliaDomain = () => {
  return window?.location?.hostname?.endsWith('telia.ee');
};

export const isBiometrySupportedByBrowser = (accountPage?: boolean) => {
  if (!window.PublicKeyCredential) {
    return false;
  }
  const isIframe = window.parent !== window;
  const requireFeaturePolicySupport = (accountPage || isIframe) && (isFirefox() || isSafari() || isChromium());
  const hasFeaturePolicySupport = !!(document as any).featurePolicy;
  const featureIsAllowed = isFeatureAllowed('publickey-credentials-get');
  return requireFeaturePolicySupport ? hasFeaturePolicySupport && featureIsAllowed : !hasFeaturePolicySupport || featureIsAllowed;
};
